import { render, staticRenderFns } from "./useCrisp.vue?vue&type=template&id=5226fa64&scoped=true"
import script from "./useCrisp.vue?vue&type=script&lang=js"
export * from "./useCrisp.vue?vue&type=script&lang=js"
import style0 from "./useCrisp.vue?vue&type=style&index=0&id=5226fa64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5226fa64",
  null
  
)

export default component.exports